import { useEffect, useState } from 'react';

/**
 * The trailing edge of a rapidly changing value.
 *
 * `TableToolbar` debounces inline because it owns an input and has to keep the
 * box responsive while the *committed* value lags. This is the other shape:
 * something already holds the value and only wants to know when it settles —
 * the merge dialog's catalog search, where a request per keystroke would query
 * a 1,500-row table five times to answer one question.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value);
    }, delayMs);

    // Cleared on every change, so only the last value in a burst ever lands.
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return settled;
}
